import { Button, InfiniteScroll, Progress } from "nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import Table from "../../../../components/Table";
import Search from "../../../../components/Search";
import withRouter from "../../../../withRouter";
import TrainingListForm from "../../Training/TrainingTable/training-list-form/TrainingListForm";
import TrainingReportListPresenter from "./TrainingReportListPresenter";
import DateRangePicker from "../../../../components/common/DateRangePicker";

class TrainingReportListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TrainingReportListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
      objects: [],
      object: {},
      action: "",
      filteredStatus: "",
      trainings: [],
      filterTrainings: "",
      isTrainingFormOpen: false,
      formMode: "Edit",
      count: 0,
      limit: 10,
      current: 1,
    };
  }
  // async componentDidMount() {
  //   this.presenter.componentDidMount();
  //   const objects = await findObjectUseCase().execute("management_training");
  //   console.log("OBJECTTSSSS", objects);
  //   const filteredObjects = objects.filter((object) => object.stats === "Done");
  //   console.dir(filteredObjects);
  //   this.setState({ training: filteredObjects });
  // }

  getCollectionName() {
    return "management_training";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  async handleAppearance(objectID) {
    console.log("OBJECT IDDD", objectID);
    this.navigateTo(`/appearance/${this.getCollectionName()}/${objectID.id}`);
  }
  async handleTraining(objectID) {
    this.navigateTo(`/training/${this.getCollectionName()}/${objectID.id}`);
  }

  // async handleEdit(objectID) {
  //   const objects = await findObjectUseCase().execute("management_training");
  //   const object = objects.find((item) => item.id === objectID);
  //   this.setState({
  //     object,
  //     action: "edit",
  //     isTrainingFormOpen: true,
  //     formMode: "Edit",
  //   });
  // }
  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }
  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, formMode, count, limit, current } = this.state;

    if (!schema) return <Progress />;

    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="">
              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center">
                  <div className="col-md-6 mt-1">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                  <div className="col-md-6 mt-1">
                    <DateRangePicker
                      fields={["datefrom", "dateto", ""]}
                      onFilter={(filterObj) => {
                        this.searchSubmit(filterObj);
                      }}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">Training List</h4>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                ofAppearance={this.handleAppearance.bind(this)}
                ofTraining={this.handleTraining.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "View Certificate",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "id",
                    "Created At",
                    "Updated At",
                    "budgets",
                    "costs",
                    "time",
                    "targetcompetency",
                    "datefrom",
                    "dateto",
                  ]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isTrainingFormOpen && (
          <TrainingListForm
            closeTrainingForm={() =>
              this.setState({ isTrainingFormOpen: false })
            }
            refetchData={this.refetchData.bind(this)}
            object={this.state.object}
            action={this.state.action}
            formMode={formMode}
          />
        )}
      </>
    );
  }
}

export default withRouter(TrainingReportListPage);
